module.exports = __webpack_public_path__ + "img/job-icon-1.03dba8c1.png";